module.exports = __webpack_public_path__ + "img/bg_common_circlebase.71a810e0.png";